<!--
 * @Author: cryi.liu
 * @Date: 2020-05-07 16:30:29
 * @LastEditTime: 2020-05-18 14:27:27
 * @Description: 题库组题
 -->
<template>
  <div class="library-com-question">
    <div class="list">
      <big-question
        v-for="bigQuestion in bigQuestions"
        :key="bigQuestion.partId"
        :big-question="bigQuestion"
        @click-update-question="clickUpdateQuestion" />
    </div>
    <create-big-question @click-question-type="clickQuestionType" />

    <ComQuestionMode
      :show="comQuestionModeModalShow"
      @visible-change="onComQuestionModeVisibleChange"
      @select-com-question-mode="selectComQuestionMode" />
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import BigQuestion from './BigQuestion.vue';
import CreateBigQuestion from './CreateBigQuestion.vue';
import ComQuestionMode from './ComQuestionMode.vue';

export default {
  name: 'LibraryComQuestion',
  components: {
    BigQuestion,
    CreateBigQuestion,
    ComQuestionMode,
  },
  data() {
    return {
      comQuestionModeModalShow: false,
      type: '',
    };
  },
  computed: {
    ...mapGetters({
      bigQuestions: 'createPaperStore/bigQuestions',
    }),
  },
  methods: {
    ...mapActions({
      setAddQuestionByProductGroupModalType: 'createPaperStore/invokeSetAddQuestionByProductGroupModalType',
      setAddQuestionByProductGroupModalShow: 'createPaperStore/invokeSetAddQuestionByProductGroupModalShow',
      setAddQuestionByProductCodeModalType: 'createPaperStore/invokeSetAddQuestionByProductCodeModalType',
      setAddQuestionByProductCodeModalShow: 'createPaperStore/invokeSetAddQuestionByProductCodeModalShow',
      setAddBigQuestionRuleOfPartId: 'createPaperStore/invokeSetAddBigQuestionRuleOfPartId',
      setAddBigQuestionRuleOfQuestionType: 'createPaperStore/invokeSetAddBigQuestionRuleOfQuestionType',
      setComQuestionType: 'createPaperStore/invokeSetComQuestionType',
    }),
    selectComQuestionMode(mode) {
      this.setComQuestionType({ comQuestionType: mode });

      if (mode === 'productGroup') {
        this.setAddQuestionByProductGroupModalType({ type: this.type });
        this.setAddQuestionByProductGroupModalShow({ show: true });

        this.type = '';
      } else if (mode === 'productCode') {
        this.setAddQuestionByProductCodeModalType({ type: this.type });
        this.setAddQuestionByProductCodeModalShow({ show: true });

        this.type = '';
      }
      this.comQuestionModeModalShow = false;
    },
    onComQuestionModeVisibleChange(flag) {
      this.comQuestionModeModalShow = flag;
    },
    clickQuestionType(type) {
      this.type = type;
      this.comQuestionModeModalShow = true;
    },
    clickUpdateQuestion(type) {
      this.type = type;
      this.comQuestionModeModalShow = true;
    },
  },
};
</script>

<style lang="less" scoped>
.library-com-question {
  width: 90%;

  > .list {
    > div {
      margin-bottom: 28px;
    }
  }
}
</style>
